<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRegistryStore } from '@/stores/registry.store'

const props = defineProps({
  id: { type: Number, required: true },
  data: { type: Object, required: true },
})

const registryStore = useRegistryStore()

const blobUrl = ref(null)
const blobType = ref(null)
let debounceTimer = null

const loadPreview = () => {
  clearTimeout(debounceTimer)
  debounceTimer = setTimeout(async() => {
    try {
      const response = await registryStore.api.previewAttachmentByIdAsync(props.id)
      blobType.value = response.data.type
      blobUrl.value = URL.createObjectURL(response.data)
    } catch (err) {
      console.error('error', err)
    }
  }, 500)
}

onMounted(() => loadPreview())
onUnmounted(() => {
  clearTimeout(debounceTimer)
  if (blobUrl.value) URL.revokeObjectURL(blobUrl.value)
})
</script>

<template>
  <div style="display: flex; align-items: center; justify-content: center; background: #f5f5f5;">
    <div v-if="blobUrl" style="width: 25rem; height: 18rem; overflow: hidden; background: white;">
      <img
        v-if="blobType?.startsWith('image/')"
        :src="blobUrl"
        :key="`img-${blobUrl}`"
        style="width: 100%; height: 100%; object-fit: contain; display: block;"
      />
      <iframe
        v-else
        :src="`${blobUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-fit&view=FitH`"
        :key="`iframe-${blobUrl}`"
        style="width: 100%; height: 100%; border: none; display: block;"
      />
    </div>
    <div
      v-else
      style="display: flex; align-items: center; justify-content: center; background: white; width: 25rem; height: 18rem;"
    >
      <q-spinner size="3em" color="primary" />
    </div>
  </div>
</template>

<style>
iframe {
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: contain;
}
</style>
